export class AssertionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AssertionError';
  }
}

export function assert(test: unknown, message: string | Error | (() => string | Error)): void {
  if (test) return;
  if (typeof message === 'function') message = message();
  throw typeof message === 'string' ? new AssertionError(message) : message;
}
